const API = "https://shopify-server-suryansh098.herokuapp.com";
export default API;
